import eOrderListDispatcher from '../action';

const initialState = {
  list: [],
  paging: {
    pageIndex: 0,
    pageSize: 10,
    totalItem: 0,
    totalPage: 0
  }
};

const eOrderListReducer = eOrderListDispatcher(initialState, {
  [eOrderListDispatcher.getDataSuccess]: (state, payload) => ({
    list: payload.data.list,
    paging: {
      ...payload.data,
      list: undefined
    }
  }),
  [eOrderListDispatcher.setState]: (state, payload) => ({
    [payload.state]: payload.value
  }),
  [eOrderListDispatcher.resetData]: (state, _) => ({
    ...initialState
  })
});

export default eOrderListReducer;
